<template>
    <button type="button" :class="classes" @click="openConfirmBox" :disabled="disabled">
        <slot>{{ $t('app.delete') }}</slot>
    </button>
</template>

<script>

import Swal from 'sweetalert2'

export default {
    name: 'DeleteButton',

    props: {
        submitFn: {
            type: Function,
            required: false,
            default: null
        },
        action: {
            type: String,
            required: true,
        },
        method: {
            type: String,
            default: 'delete',
        },
        title: {
            type: String,
            default: 'Radera?'
        },
        text: {
            type: String,
            default: 'Du kan inte ångra detta!'
        },
        confirmButton: {
            type: String,
            default: 'Radera'
        },
        cancelButton: {
            type: String,
            default: 'Avbryt'
        },
        classes: {
            type: String,
            default: 'btn btn-danger'
        },
        nextUrl: {
            type: String,
            default: null
        },
        typeToConfirm: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            csrfToken: document.head.querySelector('meta[name=csrf-token]')?.content
        }
    },

    methods: {
        async openConfirmBox() {
            const config = {
                title: this.title,
                text: this.text,
                icon: 'warning',
                confirmButtonText: this.confirmButton,
                cancelButtonText: this.cancelButton,
                showCancelButton: true,
                reverseButtons: true,
                showLoaderOnConfirm: true,
                focusCancel: true,
                customClass: {
                    confirmButton: 'btn btn-danger',
                    cancelButton: 'btn btn-success'
                }
            }

            if (this.typeToConfirm) {
                config.input = 'text'
                config.html = `
          <p>${this.text}</p>
          <p>Skriv '<strong>delete</strong>' i rutan nedan för att bekräfta</p>
        `
                config.showLoaderOnConfirm = false
            }

            const result = await Swal.fire(config)

            if (!result.isConfirmed) return

            if (this.typeToConfirm) {
                if (!result.value || result.value.toLowerCase() !== 'delete') {
                    await Swal.fire({
                        icon: 'error',
                        text: 'Inskriven text matchar inte "delete"',
                    })
                    return
                }
            }

            this.submit()
        },

        submit() {
            if (this.submitFn) {
                this.submitFn()
                Swal.close()
                return
            }

            const form = document.createElement('form')
            form.action = this.action
            form.method = 'post'

            if (this.method !== 'post') {
                const methodInput = document.createElement('input')
                methodInput.type = 'hidden'
                methodInput.name = '_method'
                methodInput.value = this.method
                form.appendChild(methodInput)
            }

            const tokenInput = document.createElement('input')
            tokenInput.type = 'hidden'
            tokenInput.name = '_token'
            tokenInput.value = this.csrfToken
            form.appendChild(tokenInput)

            if (this.nextUrl) {
                const nextInput = document.createElement('input')
                nextInput.type = 'hidden'
                nextInput.name = '_next_url'
                nextInput.value = this.nextUrl
                form.appendChild(nextInput)
            }

            document.body.appendChild(form)
            form.submit()
        }
    }
}
</script>

<style>
.swal2-input {
    color: black;
    max-width: 110px;
}
</style>